import React from "react";
import { CarouselSlide } from "../../../components/Carousel";
import { Card, CardDescription, CardTitle, CardImage } from "../../../components/Card";
import { generateGenericAnalytics } from "../../../functional/analyticsUtils";
import { ContentEngagement } from "../../../components/ContentEngagement";
import { AnalyticsProvider } from "../../../providers/AnalyticsProvider";
import { AspectRatio } from "../../../components/AspectRatio";
import { TAG_SETS } from "../../../components/RichTextHTML";
import { RichTextSmall } from "../../../components/RichText/specialties/RichTextSmall";
import { Media } from "../../../components/Media";
export const MediaPromoSlide = ({ content, slideIndex, slideTotal, ...props }) => {
    const { media, title, description } = content;
    return (React.createElement(CarouselSlide, { ...props },
        React.createElement(AnalyticsProvider, { uiLocation: `slide[${slideIndex + 1}:${slideTotal}]` },
            React.createElement(ContentEngagement, { contentAnalytics: generateGenericAnalytics(content, "PromoCard") },
                React.createElement(Card, null,
                    React.createElement(CardImage, null,
                        React.createElement(AspectRatio, { ratio: 3 / 4 }, media && React.createElement(Media, { media: media }))),
                    React.createElement("div", { className: "content" },
                        title && React.createElement(CardTitle, null, title),
                        description && (React.createElement(CardDescription, null,
                            React.createElement(RichTextSmall, { ...description, allowedTags: TAG_SETS.INLINE_TAGS })))))))));
};
//# sourceMappingURL=LandingPromoCard.js.map